import {useEffect, useState} from 'react';
import {getLocationInventory} from '../utils/getLocationInventory';
import {NZOrAU, PreOrderConfig} from '../types';

type Props = {
  countryCode: string;
  gid: string;
  preOrderConfig: PreOrderConfig[];
};

type StockAtCountry = {
  quantity: number;
  continueSellingWhenOutOfStock: boolean;
};

export function useInventory(props: Props) {
  const [stockAtCountry, setStockAtCountry] = useState<StockAtCountry | null>(
    null,
  );

  useEffect(() => {
    getLocationInventory(props.countryCode, props.gid).then((res) => {
      if (!res) return;
      setStockAtCountry({
        quantity: res.quantity || 0,
        continueSellingWhenOutOfStock: !!res.continueSellingWhenOutOfStock,
      });
    });
  }, []);

  const showPreorder = !!props.preOrderConfig?.find((config) =>
    config.location?.includes(
      (props.countryCode?.toLowerCase() as NZOrAU) || 'nz',
    ),
  );

  const continueSellingWhenOutOfStock =
    stockAtCountry?.continueSellingWhenOutOfStock &&
    !!!props.preOrderConfig?.find((config) =>
      config.ignoreContinueSelling?.includes(
        (props.countryCode?.toLowerCase() as NZOrAU) || 'nz',
      ),
    );

  const showOutOfStock =
    stockAtCountry !== null &&
    stockAtCountry.quantity <= 0 &&
    !continueSellingWhenOutOfStock;

  return [showPreorder, showOutOfStock];
}
